import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/CustomerExperiences.css';

// British English comment: Updated activity cards to use the provided scenery images
const activityCards = [
  {
    key: 'sightseeing',
    img: process.env.PUBLIC_URL + '/images/scene7.jpg',
    overlay: 'linear-gradient(135deg, #7f53ac 0%, #647dee 100%)',
  },
  {
    key: 'bikeHire',
    img: process.env.PUBLIC_URL + '/images/scene6.jpg',
    overlay: 'linear-gradient(135deg, #43cea2 0%, #185a9d 100%)',
  },
  {
    key: 'wildlife',
    img: process.env.PUBLIC_URL + '/images/scenery1.jpg',
    overlay: 'linear-gradient(135deg, #f7971e 0%, #ffd200 100%)',
  },
  {
    key: 'photography',
    img: process.env.PUBLIC_URL + '/images/scenerty3.jpg',
    overlay: 'linear-gradient(135deg, #f953c6 0%, #b91d73 100%)',
  },
  {
    key: 'picnic',
    img: process.env.PUBLIC_URL + '/images/scenery2.jpg',
    overlay: 'linear-gradient(135deg, #56ab2f 0%, #a8e063 100%)',
  },
  {
    key: 'waterSports',
    img: process.env.PUBLIC_URL + '/images/scene7.jpg',
    overlay: 'linear-gradient(135deg, #36d1c4 0%, #1e3799 100%)',
  },
];

const CustomerExperiences: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* Customer Experiences Section */}
      <section className="experiences-section">
        <div className="experiences-container">
          <h2>{t('experiences.title')}</h2>
          <p className="experiences-subtitle">{t('experiences.subtitle')}</p>
          <div className="experiences-grid">
            {/* Experience Cards */}
            <div className="experience-card">
              <h3>{t('experiences.experience1.title')}</h3>
              <p className="experience-content">{t('experiences.experience1.content')}</p>
              <div className="experience-author">
                <p className="author-name">{t('experiences.experience1.author')}</p>
                <p className="experience-date">{t('experiences.experience1.date')}</p>
              </div>
            </div>
            <div className="experience-card">
              <h3>{t('experiences.experience2.title')}</h3>
              <p className="experience-content">{t('experiences.experience2.content')}</p>
              <div className="experience-author">
                <p className="author-name">{t('experiences.experience2.author')}</p>
                <p className="experience-date">{t('experiences.experience2.date')}</p>
              </div>
            </div>
            <div className="experience-card">
              <h3>{t('experiences.experience3.title')}</h3>
              <p className="experience-content">{t('experiences.experience3.content')}</p>
              <div className="experience-author">
                <p className="author-name">{t('experiences.experience3.author')}</p>
                <p className="experience-date">{t('experiences.experience3.date')}</p>
              </div>
            </div>
            <div className="experience-card">
              <h3>{t('experiences.experience4.title')}</h3>
              <p className="experience-content">{t('experiences.experience4.content')}</p>
              <div className="experience-author">
                <p className="author-name">{t('experiences.experience4.author')}</p>
                <p className="experience-date">{t('experiences.experience4.date')}</p>
              </div>
            </div>
            <div className="experience-card">
              <h3>{t('experiences.experience5.title')}</h3>
              <p className="experience-content">{t('experiences.experience5.content')}</p>
              <div className="experience-author">
                <p className="author-name">{t('experiences.experience5.author')}</p>
                <p className="experience-date">{t('experiences.experience5.date')}</p>
              </div>
            </div>
            <div className="experience-card">
              <h3>{t('experiences.experience6.title')}</h3>
              <p className="experience-content">{t('experiences.experience6.content')}</p>
              <div className="experience-author">
                <p className="author-name">{t('experiences.experience6.author')}</p>
                <p className="experience-date">{t('experiences.experience6.date')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Activities Section styled like the screenshot */}
      <section className="activities-section">
        <div className="activities-container">
          <h2 className="activities-title">{t('activities.title')}</h2>
          <div className="activities-grid">
            {activityCards.map((activity) => (
              <div className="activity-card" key={activity.key}>
                {/* Image with overlay */}
                <div
                  className="activity-image-wrapper"
                  style={{ backgroundImage: `${activity.overlay}, url(${activity.img})` }}
                >
                  <img
                    src={activity.img}
                    alt={t(`activities.${activity.key}.title`)}
                    className="activity-image"
                  />
                  <div
                    className="activity-overlay"
                    style={{ background: activity.overlay }}
                  />
                </div>
                {/* Title and description */}
                <div className="activity-content">
                  <h3 className="activity-title">{t(`activities.${activity.key}.title`)}</h3>
                  <p className="activity-description">{t(`activities.${activity.key}.description`)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Map Section for Loch Lomond */}
      <section className="map-section">
        <div className="map-container">
          <h2 className="map-title">{t('map.title')}</h2>
          <p className="map-description">{t('map.description')}</p>
          {/* Responsive Mapbox/OSM iframe */}
          <div className="map-embed-wrapper">
            <iframe
              title="Loch Lomond Map"
              src="https://www.openstreetmap.org/export/embed.html?bbox=-4.740%2C56.050%2C-4.500%2C56.150&amp;layer=mapnik"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section id="contact" className="contact-simple-section">
        <div className="contact-simple-container">
          <h2 className="contact-simple-title">{t('contactSimple.title')}</h2>
          <form 
            className="contact-simple-form" 
            action="https://formspree.io/f/mpwranyv" 
            method="POST"
            autoComplete="off"
          >
            <div className="contact-simple-group">
              <label htmlFor="contact-name">{t('contactSimple.name')}</label>
              <input
                id="contact-name"
                name="name"
                type="text"
                required
                autoComplete="off"
              />
            </div>
            <div className="contact-simple-group">
              <label htmlFor="contact-email">{t('contactSimple.email')}</label>
              <input
                id="contact-email"
                name="email"
                type="email"
                required
                autoComplete="off"
              />
            </div>
            <div className="contact-simple-group">
              <label htmlFor="contact-message">{t('contactSimple.message')}</label>
              <textarea
                id="contact-message"
                name="message"
                required
                rows={5}
                autoComplete="off"
              />
            </div>
            <button 
              type="submit"
              className="contact-simple-btn"
              onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.currentTarget.form?.requestSubmit(); } }}
              aria-pressed="false"
              tabIndex={0}
              onTouchStart={e => e.currentTarget.classList.add('pressed')}
              onTouchEnd={e => e.currentTarget.classList.remove('pressed')}
              onMouseDown={e => e.currentTarget.classList.add('pressed')}
              onMouseUp={e => e.currentTarget.classList.remove('pressed')}
              onBlur={e => e.currentTarget.classList.remove('pressed')}
            >
              {t('contactSimple.submit')}
            </button>
          </form>
        </div>
      </section>
    </>
  );
};

export default CustomerExperiences; 